import { render } from "./CustomerAgreement.vue?vue&type=template&id=b69a9e90"
import script from "./CustomerAgreement.vue?vue&type=script&lang=js"
export * from "./CustomerAgreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__